import axios, { Axios } from "axios";

export class ApiConfig {
   client: Axios;
   constructor(baseURL) {
      this.client = axios.create({
         baseURL: baseURL,
         timeout: 60000,
         withCredentials: true,
      });
      this.client.interceptors.request.use(
         (config) => {
            return config;
         },
         (error) => {
            return Promise.reject(new Error(error));
         }
      );
      this.client.interceptors.response.use(
         (response) => response,
         (error) => {
            return Promise.reject(new Error(error));
         }
      );
   }

   async get(url, config = {}) {
      try {
         axios.defaults.withCredentials = true;
         const response = await this.client.get(url, config);
         return response.data;
      } catch (err) {
         console.error(err);
      }
   }

   async post(url, data, config = {}) {
      try {
         axios.defaults.withCredentials = true;
         const response = await this.client.post(url, data, config);
         return response.data;
      } catch (err) {
         console.error(err);
      }
   }

   async put(url, data, config = {}) {
      try {
         axios.defaults.withCredentials = true;
         const response = await this.client.put(url, data, config);
         return response.data;
      } catch (err) {
         console.error(err);
      }
   }

   async delete(url, config = {}) {
      try {
         axios.defaults.withCredentials = true;
         const response = await this.client.delete(url, config);
         return response.data;
      } catch (err) {
         console.error(err);
      }
   }
}
